module.exports = __webpack_public_path__ + "img/about_banner.1c7877dd.webp";